import { ImageProps } from 'next/image';

import { ImageWithPlaceholder } from '@/components/ImageWithPlaceholder';
import { ImageDto } from '@/lib/image.dto';

type GallerySummaryImageProps = {
  image: ImageDto;
  className?: string;
  sizes: ImageProps['sizes'];
  priority?: ImageProps['priority'];
  placeholder?: ImageProps['placeholder'];
  blurDataURL?: ImageProps['blurDataURL'];
  loading?: ImageProps['loading'];
};

export function GallerySummaryImage({
  image,
  sizes,
  priority,
  placeholder,
  blurDataURL,
  className,
  loading,
}: GallerySummaryImageProps) {
  return (
    <>
      <ImageWithPlaceholder
        className={className}
        alt={image.altText}
        src={image.url}
        width="640"
        height="360"
        sizes={sizes}
        placeholder={placeholder}
        blurDataURL={blurDataURL}
        priority={priority}
        loading={loading}
      />
      {image.isDefault && (
        <p className="absolute z-[1] bottom-3 right-3 text-white text-xs">
          {image.caption}
        </p>
      )}
    </>
  );
}
